module.exports = __webpack_public_path__ + "img/golden_oak_696l_detail_rsh2.e947c32e.jpg";